import { Get, getAPIUrl, Post } from "../../../ApiServices/apiMethod";

export const EkoEndpoint = {
  getEkoPayoutBank: "Api/eko/Payout/getPayoutBanks",
  getEkoCreditCardBanks: "Api/eko/creditcard/getBanks",
  PayCreditCardBill: "Api/eko/creditcard/payBill",
  EkoPayout: "Api/eko/Payout/payout",
  ekoPayoutReport: "Api/eko/Payout/payoutReport",
  ekoQrGenerate: "Api/eko/QrPayment/generateQRLink",
  ekoStaticQrGenerate: "Api/eko/QrPaymentStatic/generateQRStaticLink",
  ekoQrReport: "Api/eko/QrPayment/report",
  ekoStaticQrReport: "",
  getEkoBanks: "Api/V1/Member/getBanks",
  verifyBankDetail: "Api/V1/Verification/verifyBankDetails",
  bankverifyReport: "Api/eko/BankVerification/report",
  panverify: "Api/eko/PanVerification/verifyPanDetails",
  ekoPanReport: "Api/eko/PanVerification/report",
  ekocms: "Api/eko/cms/ekoCMSRequestGenerate",
  ekoCmsReport: "Api/eko/cms/cmsReport",
  getekoBBPSReport: "Api/eko/Bbps/bbpsReport",
  getekoBBPSofflineReport: "Api/eko/BbpsOffline/bbpsReport",
  getEkoBanksExpress: "Api/eko/XpressPayout/getEkoDmtBanks",
  ekoExpressPay: "Api/eko/XpressPayout/xpressPayout",
  ekoGetBeneficiary: "Api/eko/XpressPayout/getBeneficiaries",
  ekoBankVerifyReport: "Api/eko/BankVerification/report",
  ekoaadharConcent: "Api/eko/AadharVerification/getAdhaarConsent",
  ekoaadharOtp: "Api/eko/AadharVerification/getAdhaarOtp",
  ekoVerifyAadharDetail: "Api/eko/AadharVerification/verifyAadharDetails",
  ekoaadharReport: "Api/eko/AadharVerification/report",
  ekoCreditCardReport: "Api/Eko/CreditCard/Report",
  getBbpsOperatorCategory: "Api/eko/Bbps/getOperatorCategopry",
  getEkoBbpsOperator: "Api/eko/Bbps/operators/",
  getEkoBbpsformParams: "Api/eko/Bbps/formParameters/",
  payEkoBill: "Api/eko/Bbps/billPayment/",
  payEkoOfflineBill: "Api/eko/BbpsOffline/billPayment/",
  fetchEkoBill: "Api/eko/Bbps/fetchBill/",
  fetchEkoOfflineBill: "Api/eko/BbpsOffline/fetchBill/electricity",
  getEkoBbpsOfflineOperator: "Api/eko/BbpsOffline/operators/",
  getEkoBbpsOfflineformParams: "Api/eko/BbpsOffline/formParameters/",
  getBbpsOfflineOperatorCategory: "Api/eko/BbpsOffline/getOperatorCategopry",
  //DMT
  getEkoCustomers: "Api/Eko/DMT/getCustomer",
  addEkoDmtCustomers: "Api/Eko/DMT/createCustomer",
  verifyCustomerOtp: "Api/Eko/DMT/customerOTPVerify",
  customerEkoDMTKyc: "Api/Eko/DMT/customerKyc",
  verifyekoDMTOtp: "Api/Eko/DMT/customerOTPVerify",
  ekomerchantOnboard: "Api/eko/ekomaster/merchantOnboard",
  addReceipient: "Api/Eko/DMT/addRecipient",
  getEkoReceipients: "Api/Eko/DMT/getRecipients",
  ekodmtReceipientFundTransferOtp: "Api/Eko/Dmt/generateOtp",
  getEkoDmtBanks: "Api/eko/ekomaster/getEkoBanks",
};

export const getEkoPayBanks = (param = "") => {
  const url = getAPIUrl(EkoEndpoint.getEkoPayoutBank, param);
  return Get(url);
};
export const getEkoBbpsOperator = (param = "") => {
  const url = getAPIUrl(EkoEndpoint.getEkoBbpsOperator, param);
  return Get(url);
};
export const getEkoBbpsOfflineOperator = (param = "") => {
  const url = getAPIUrl(EkoEndpoint.getEkoBbpsOfflineOperator, param);
  return Get(url);
};
export const payEkoBill = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.payEkoBill, param);
  return Post(url, data);
};
export const payEkoOfflineBill = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.payEkoOfflineBill, param);
  return Post(url, data);
};
export const getEkoCreditCardBanks = (param = "") => {
  const url = getAPIUrl(EkoEndpoint.getEkoCreditCardBanks, param);
  return Get(url);
};
export const getBbpsOperatorCategory = (param = "") => {
  const url = getAPIUrl(EkoEndpoint.getBbpsOperatorCategory, param);
  return Get(url);
};
export const getBbpsOfflineOperatorCategory = (param = "") => {
  const url = getAPIUrl(EkoEndpoint.getBbpsOfflineOperatorCategory, param);
  return Get(url);
};
export const PayCreditCardBill = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.PayCreditCardBill, param);
  return Post(url, data);
};
export const DoEkoPay = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.EkoPayout, param);
  return Post(url, data);
};

export const getEkoPayReport = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoPayoutReport, param);
  return Post(url, data);
};

export const getEkoQrCode = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoQrGenerate, param);
  return Post(url, data);
};
export const getEkoQrReport = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoQrReport, param);
  return Post(url, data);
};
export const getEkoStaticQrCode = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoStaticQrGenerate, param);
  return Post(url, data);
};
export const getEkoStaticQrReport = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoStaticQrReport, param);
  return Post(url, data);
};
export const getEkoBanks = (param = "") => {
  const url = getAPIUrl(EkoEndpoint.getEkoBanks, param);
  return Get(url);
};
export const EkoverifyBank = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.verifyBankDetail, param);
  return Post(url, data);
};
export const fetchEkoBill = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.fetchEkoBill, param);
  return Post(url, data);
};
export const fetchEkoOfflineBill = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.fetchEkoOfflineBill, param);
  return Post(url, data);
};
export const EkoVerifyBankReport = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.bankverifyReport, param);
  return Post(url, data);
};
export const GetEkoBankVerifyReport = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoBankVerifyReport, param);
  return Post(url, data);
};

export const EkoverifyPan = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.panverify, param);
  return Post(url, data);
};
export const getEkoPanReport = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoPanReport, param);
  return Post(url, data);
};
export const getEkoCreditCardReport = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoCreditCardReport, param);
  return Post(url, data);
};
export const EkoCmsGenerate = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekocms, param);
  return Post(url, data);
};
export const getEkoCmsReport = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoCmsReport, param);
  return Post(url, data);
};
export const getekoBBPSofflineReport = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.getekoBBPSofflineReport, param);
  return Post(url, data);
};
export const getekoBBPSReport = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.getekoBBPSReport, param);
  return Post(url, data);
};

export const getEkoBbpsformParams = (param = "") => {
  const url = getAPIUrl(EkoEndpoint.getEkoBbpsformParams, param);
  return Get(url);
};
export const getEkoBbpsOfflineformParams = (param = "") => {
  const url = getAPIUrl(EkoEndpoint.getEkoBbpsOfflineformParams, param);
  return Get(url);
};
export const EkoDoExpressPay = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoExpressPay, param);
  return Post(url, data);
};
export const EkoGetExpressBene = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoGetBeneficiary, param);
  return Post(url, data);
};

export const EkobankExpress = (param = "") => {
  const url = getAPIUrl(EkoEndpoint.getEkoBanksExpress, param);
  return Get(url);
};

export const EkoAadharConcent = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoaadharConcent, param);
  return Post(url, data);
};

export const EkoAadharOtp = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoaadharOtp, param);
  return Post(url, data);
};

export const DoEkoAadharVerify = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoVerifyAadharDetail, param);
  return Post(url, data);
};

export const getEkoAadharReport = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekoaadharReport, param);
  return Post(url, data);
};

export const getEkoCustomers = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.getEkoCustomers, param);
  return Post(url, data);
};
export const addEkoDmtCustomers = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.addEkoDmtCustomers, param);
  return Post(url, data);
};

export const customerEkoDMTKyc = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.customerEkoDMTKyc, param);
  return Post(url, data);
};
export const verifyekoDMTOtp = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.verifyekoDMTOtp, param);
  return Post(url, data);
};
export const ekomerchantOnboard = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekomerchantOnboard, param);
  return Post(url, data);
};
export const addReceipient = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.addReceipient, param);
  return Post(url, data);
};
export const getEkoReceipients = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.getEkoReceipients, param);
  return Post(url, data);
};
export const ekodmtReceipientFundTransferOtp = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.ekodmtReceipientFundTransferOtp, param);
  return Post(url, data);
};
export const getEkoDmtBanks = (data, param = "") => {
  const url = getAPIUrl(EkoEndpoint.getEkoDmtBanks, param);
  return Post(url, data);
};
